<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-form ref="formNovoSeguro" v-model="formValidNovoSeguro">
                <v-layout row wrap>

                    <v-flex xs12 sm4>
                      <h4 class="primary--text">Informe o tipo de seguro desejado*</h4>
                        <v-autocomplete label="Tipo de Seguro*" required
                        id="txtNovoSeguroTipoSeguro"
                        :items="lstOpcoesTipoSeguro"
                        item-text="tipoSeguro"
                        item-value="tipoSeguro"
                        :error-messages="regras.tipoSeguro"
                        v-model="modelFormatado.tipoSeguro"></v-autocomplete>
                    </v-flex>
                    <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                    <v-flex xs12 sm5 v-show="modelFormatado.tipoSeguro && (modelFormatado.tipoSeguro == 'Acidente' || modelFormatado.tipoSeguro == 'Acidente e Roubo')">
                      <h4 class="primary--text">Informe o valor da taxa ou do desconto desejado no Novo Seguro de Acidente*</h4>
                      <v-radio-group id="taxaDescontoDesejadosRadio" class="pb-0" :rules="regras.taxaDescontoNovoSeguroRadio" v-model="taxaDescontoNovoSeguroRadioStr" @change="zeraTaxaDescontoNovoSeguroTextField()" row required>
                        <v-radio color="primary" id="chkTaxaSegurosNovoSeguro" label="Taxa" value="taxa"></v-radio>
                        <v-radio color="primary" id="chkDescontoSegurosNovoSeguro" label="Desconto" value="desconto"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <template v-show="modelFormatado.tipoSeguro && (modelFormatado.tipoSeguro == 'Acidente' || modelFormatado.tipoSeguro == 'Acidente e Roubo')">
                      <v-flex sm7 v-show="taxaDescontoNovoSeguroRadioStr == 'taxa'"></v-flex>
                      <v-flex xs12 sm4 class="pt-0" v-show="taxaDescontoNovoSeguroRadioStr == 'taxa'">
                        <v-text-field label="Taxa*"
                        v-model="modelFormatado.taxaDesejada"
                        validate-on-blur
                        ref="txtNovoSeguroTaxaDesejadaLabelRef"
                        id="txtNovoSeguroTaxaDesejada"
                        :rules="regras.porcentagemTaxa"
                        hint="Informe a taxa com 3 casas decimais no máximo"
                        required
                        maxlength="7">
                        </v-text-field>
                      </v-flex>
                    </template>
                    <template>
                        <v-flex sm7 v-show="taxaDescontoNovoSeguroRadioStr == 'desconto'"></v-flex>
                        <v-flex xs12 sm4 class="pt-0" v-show="taxaDescontoNovoSeguroRadioStr == 'desconto'">
                            <v-text-field label="Desconto*"
                            v-model="modelFormatado.descontoDesejado"
                            validate-on-blur
                            ref="txtNovoSeguroDescontoDesejadoLabelRef"
                            id="txtNovoSeguroDescontoDesejado"
                            :rules="regras.porcentagemDesconto"
                            hint="Informe o desconto com 2 casas decimais no máximo"
                            required
                            maxlength="6">
                            </v-text-field>
                        </v-flex>
                    </template>
                    <template>
                      <v-flex xs12 v-if="!$vuetify.breakpoint.xsOnly" v-show="modelFormatado.tipoSeguro == 'Acidente e Roubo'">
                        <h4 class="primary--text">Informe o valor da taxa no Novo Seguro de Roubo*</h4>
                      </v-flex>
                      <v-flex xs12 sm4 class="pt-0" v-show="modelFormatado.tipoSeguro == 'Acidente e Roubo'">
                        <v-text-field label="Taxa desejada*"
                        v-model="modelFormatado.taxaCoberturaRoubo"
                        validate-on-blur
                        ref="txtNovoSegurotaxaCoberturaRouboLabelRef"
                        id="txtNovoSegurotaxaCoberturaRoubo"
                        :rules="regras.porcentagemTaxa"
                        hint="Informe a taxa com 3 casas decimais no máximo"
                        required
                        maxlength="7">
                        </v-text-field>
                      </v-flex>
                    </template>
                    <v-flex class="pa-0" sm10 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                    <v-flex xs12 sm4>
                        <h4 class="primary--text">Informe a data estimada para início da vigência*</h4>
                        <v-menu
                            ref="modalDataVigencia"
                            lazy
                            :close-on-content-click="false"
                            v-model="modalDataVigencia"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            min-width="290px"
                            :return-value.sync="novoSeguro.dataVigencia">
                            <v-text-field
                            slot="activator"
                            label="Data de início da vigência"
                            v-model="modelFormatado.dataVigencia"
                            prepend-icon="event"
                            id="txtNovoSeguroDataVigencia"
                            required
                            clearable
                            readonly
                            ></v-text-field>
                            <v-date-picker v-model="novoSeguro.dataVigencia"
                            :min="(new Date()).toISOString().substring(0, 10)"
                            locale="pt-br"
                            @input="$refs.modalDataVigencia.save(novoSeguro.dataVigencia)"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                    <v-flex xs12 sm5>
                        <h4 class="primary--text">Contato para averbação do novo seguro*</h4>
                        <v-radio-group required :rules="regras.contatoAverbacaoStr" v-model="contatoAverbacaoStr" row>
                            <v-radio color="primary" id="chkMesmoNovoSeguroContatoAverbacao" label="O mesmo" value="true"></v-radio>
                            <v-radio color="primary" id="chkOutroNovoSeguroContatoAverbacao" label="Outro" value="false"></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex sm7 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                    <template>
                        <v-flex xs12 sm6 v-show="!boolContatoAverbacao && contatoAverbacaoStr">
                            <v-text-field label="Nome" required
                            id="txtNovoSeguroContatoNome"
                            ref="txtNovoSeguroContatoNomeRef"
                            :rules="formRulesComputed.usuario.nome(novoSeguro.contato.nome)"
                            v-model="novoSeguro.contato.nome"
                            validate-on-blur
                            ></v-text-field>
                        </v-flex>
                        <v-flex sm6 v-if="!$vuetify.breakpoint.xsOnly" v-show="!boolContatoAverbacao && contatoAverbacaoStr"></v-flex>
                        <v-flex xs12 sm6 v-show="!boolContatoAverbacao && contatoAverbacaoStr">
                            <v-text-field label="E-mail" required
                            id="txtNovoSeguroContatoEmail"
                            ref="txtNovoSeguroContatoEmailRef"
                            :rules="formRulesComputed.usuario.email(novoSeguro.contato.email, false)"
                            v-model="novoSeguro.contato.email"
                            validate-on-blur
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs4 sm2 v-show="!boolContatoAverbacao && contatoAverbacaoStr">
                            <v-text-field required label="DDD"
                            id="txtNovoSeguroContatoDdd"
                            ref="txtNovoSeguroContatoDddRef"
                            :rules="formRulesComputed.telefone.ddd(novoSeguro.contato.ddd)"
                            v-model="novoSeguro.contato.ddd"
                            mask="##"
                            maxlength="2"
                            validate-on-blur
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs8 sm4 v-show="!boolContatoAverbacao && contatoAverbacaoStr">
                            <v-text-field required label="Telefone"
                            id="txtNovoSeguroContatoTelefone"
                            ref="txtNovoSeguroContatoTelefoneRef"
                            :rules="formRulesComputed.telefone.numero(novoSeguro.contato.telefone)"
                            v-model="novoSeguro.contato.telefone"
                            validate-on-blur></v-text-field>
                        </v-flex>
                    </template>
                    <v-flex xs12><h4 class="primary--text">Expectativa para cotação</h4></v-flex>
                    <v-flex xs12>
                        <v-textarea 
                          label="Conte-nos mais sobre sua expectativa para essa cotação"
                          id="txtNovoSeguroContatoExpectativa"
                          :rules="regras.expectativa"
                          v-model="novoSeguro.expectativa"
                        ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                        <v-btn flat
                            :block="$vuetify.breakpoint.xsOnly" 
                            color="primary"
                            id="btnAnteriorNovoSeguro"
                            @click.native="elementoPai.passoAnterior()">
                                <v-icon left class="hidden-sm-and-down">chevron_left</v-icon>
                                Anterior
                        </v-btn>
                        <v-btn :disabled="!passoValido || elementoPai.envioFinalizado"
                            :block="$vuetify.breakpoint.xsOnly"
                            id="btnEnviarNovoSeguro"
                            :loading="elementoPai.loadingEnvio"
                            @click.native="elementoPai.enviaQuestionario()"
                            color="primary white--text">
                                Enviar 
                                <v-icon right class="hidden-sm-and-down">send</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
import CustomFormat from '@/helpers/custom-format';
import {VMoney} from 'v-money';
import formRules from '@/helpers/form-rules';
import usuarioHelper from '@/helpers/usuario-logado';

export default {
    name: 'novoseguroq',
    directives: {
        money: VMoney
    },
    data: () => {
        return {
            questionarioPai: null,
            dataHoraInicio: '',
            tempoPreenchimentoTotal: '',
            formValidNovoSeguro: false,
            taxaDescontoNovoSeguroRadioStr: null,
            modalDataVigencia: false,
            modelFormatado: {
                dataVigencia: '',
                tipoSeguro: null,
                taxaDesejada: "0,00",
                taxaCoberturaRoubo: "0,00",
                descontoDesejado: "0,00"
            },
            lstOpcoesTipoSeguro: [
              {id: 1, tipoSeguro: 'Acidente'},
              {id: 2, tipoSeguro: 'Acidente e Roubo'}
            ],
            coberturaRouboStr: null,
            contatoAverbacaoStr: null,
            novoSeguro: {
                coberturaRoubo: null,
                tipoSeguro: null,
                taxaCoberturaRoubo: 0.00,
                dataVigencia: '',
                taxaDesejada: 0.0,
                descontoDesejado: 0.0,
                expectativa: '',
                contato: {
                    nome: '',
                    email: '',
                    ddd: null,
                    telefone: ''
                }
            },
            regras: {
                /*coberturaRouboStr: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],*/
                taxaDescontoNovoSeguroRadio: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],
                contatoAverbacaoStr: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],
                porcentagemTaxa: [
                  v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
                  v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
                  v => (   (/^(100)$/g.test(v) && v.length < 8 )
                        || (/^(100\,\d{1,3})$/g.test(v) && v.length < 8 )
                        || (/^(\d{2})$/g.test(v) && v.length < 7)
                        || (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7)
                        || (/^(\d{1})$/g.test(v) && v.length < 6)
                        || (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) )
                        || 'Você precisa informar um valor válido'
                ],
                porcentagemDesconto: [
                  v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
                  v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
                  v => (   (/^(100)$/g.test(v) && v.length < 8 )
                        || (/^(100\,\d{1,2})$/g.test(v) && v.length < 8 )
                        || (/^(\d{2})$/g.test(v) && v.length < 6)
                        || (/^(\d{2}\,\d{1,2})$/g.test(v) && v.length < 6)
                        || (/^(\d{1})$/g.test(v) && v.length < 5)
                        || (/^(\d{1}\,\d{1,2})$/g.test(v) && v.length < 5) )
                        || 'Você precisa informar um valor válido'
                ],
                expectativa: [
                  v => v.length == 0 || v.length <= 700 || 'A expectativa deve ter menos de 700 caracteres'
                ]
            }
        }
    },
    computed: {
        elementoPai: function () {
            return this.$parent.$parent.$parent;
        },
        passoValido: function () {
            const self = this;
            self.formValidNovoSeguro = 
                self.novoSeguro.tipoSeguro != null &&
                self.taxaDescontoNovoSeguroRadioStr != null &&
                ((self.taxaDescontoNovoSeguroRadioStr == 'taxa' &&
                self.novoSeguro.taxaDesejada > 0 && self.novoSeguro.taxaDesejada <= 100) ||
                (self.taxaDescontoNovoSeguroRadioStr == 'desconto' &&
                self.novoSeguro.descontoDesejado >= 0 && self.novoSeguro.descontoDesejado <= 100)) &&
                self.contatoAverbacaoStr != null &&
                ((self.contatoAverbacaoStr == 'false' &&
                self.novoSeguro.contato.nome != '' &&
                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(self.novoSeguro.contato.email) &&
                self.novoSeguro.contato.ddd.length == 2 &&
                self.novoSeguro.contato.telefone.length >= 8) ||
                (self.contatoAverbacaoStr == 'true')) &&
                self.modelFormatado.tipoSeguro != null &&
                ((self.modelFormatado.tipoSeguro == 'Acidente e Roubo' &&
                self.novoSeguro.taxaCoberturaRoubo > 0 && self.novoSeguro.taxaCoberturaRoubo <= 100) ||
                (self.modelFormatado.tipoSeguro == 'Acidente')) &&
                self.novoSeguro.expectativa.length <= 700 &&
                (self.novoSeguro.dataVigencia && self.novoSeguro.dataVigencia != '') &&
                (self.modelFormatado.dataVigencia && self.modelFormatado.dataVigencia != '');
            return self.formValidNovoSeguro;
        },
        boolContatoAverbacao: function () {
            return this.contatoAverbacaoStr == 'true';
        },
        /*boolCoberturaRoubo: function () {
            return this.coberturaRouboStr == 'true';
        },*/
        formRulesComputed: function() {
          return formRules;
        }
    },
    watch: {
        contatoAverbacaoStr: function (val) {
            const self = this;
            if (val == 'true') {
                self.$refs.txtNovoSeguroContatoNomeRef.reset();
                self.novoSeguro.contato.nome = '';
                self.$refs.txtNovoSeguroContatoEmailRef.reset();
                self.novoSeguro.contato.email = '';
                self.$refs.txtNovoSeguroContatoDddRef.reset();
                self.novoSeguro.contato.ddd = '';
                self.$refs.txtNovoSeguroContatoTelefoneRef.reset();
                self.novoSeguro.contato.telefone = '';
            }
        },
        'modelFormatado.tipoSeguro': function (val) {
            if (val == 'Acidente e Roubo') {
                this.novoSeguro.coberturaRoubo = val == 'Acidente e Roubo';
            } else {
                this.novoSeguro.coberturaRoubo = val == 'Acidente e Roubo';
                this.novoSeguro.taxaCoberturaRoubo = 0.0;
                this.modelFormatado.taxaCoberturaRoubo = "0";
            }
            this.novoSeguro.tipoSeguro = val ? this.modelFormatado.tipoSeguro : null;
        },
        'modelFormatado.dataVigencia': function (val) {
            if (!val) this.novoSeguro.dataVigencia = null;
        },
        'novoSeguro.dataVigencia': function (val) {
            this.modelFormatado.dataVigencia = val ? CustomFormat.toLocaleDateString(val) : '';
        },
        'modelFormatado.taxaDesejada': function (val) {
            this.novoSeguro.taxaDesejada = CustomFormat.removePercentFormat(val);
        },
        'modelFormatado.taxaCoberturaRoubo': function (val) {
            this.novoSeguro.taxaCoberturaRoubo = CustomFormat.removePercentFormat(val);
        },
        'modelFormatado.descontoDesejado': function (val) {
            this.novoSeguro.descontoDesejado = CustomFormat.removePercentFormat(val);
        }
    },
    mounted: function () {
        this.resetDataHoraInicio();
    },
    methods: {
        usarQuestionarioPai: function(param) {
          const self = this;
          self.questionarioPai = param;
          self.modelFormatado.tipoSeguro = self.questionarioPai.tipoSeguro;
          if(parseFloat(self.questionarioPai.descontoDesejado) > 0) {
            self.taxaDescontoNovoSeguroRadioStr = 'desconto';
            self.modelFormatado.descontoDesejado = CustomFormat.pontoParaVirgula(self.questionarioPai.descontoDesejado.toFixed(2));
          } else {
            self.taxaDescontoNovoSeguroRadioStr = 'taxa';
            self.modelFormatado.taxaDesejada = CustomFormat.pontoParaVirgula(self.questionarioPai.taxaDesejada.toFixed(3));
          }             
          self.coberturaRouboStr = self.questionarioPai.coberturaRoubo.toString();
          self.modelFormatado.taxaCoberturaRoubo = CustomFormat.pontoParaVirgula(self.questionarioPai.taxaCoberturaRoubo.toFixed(3));
          
          if (self.questionarioPai.contatos[0].email != usuarioHelper.USUARIO_LOGADO().email) {
            self.contatoAverbacaoStr = 'false';
            self.novoSeguro.contato.nome = self.questionarioPai.contatos[0].nome;
            self.novoSeguro.contato.email = self.questionarioPai.contatos[0].email;
            self.novoSeguro.contato.ddd = self.questionarioPai.contatos[0].ddd.toString();
            self.novoSeguro.contato.telefone = self.questionarioPai.contatos[0].telefone;
          } else {
            self.contatoAverbacaoStr = 'true';
          }
        },
        resetDataHoraInicio: function () {
            this.dataHoraInicio = new Date();
        },
        somaTempoPreenchimentoTotal: function () {
            const self = this;
            var dateTimeNow = new Date();
            if (self.tempoPreenchimentoTotal == '') {
                self.tempoPreenchimentoTotal = parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60));
            } else {
                self.tempoPreenchimentoTotal += (parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60)));
            }
        },
        montaModelo: function (contatoUsuario) {
            const self = this;
            let modelo = {};

            modelo.coberturaRoubo = self.novoSeguro.coberturaRoubo;
            modelo.taxaDesejada = self.novoSeguro.taxaDesejada;
            modelo.taxaCoberturaRoubo = self.novoSeguro.taxaCoberturaRoubo;
            modelo.descontoDesejado = self.novoSeguro.descontoDesejado;
            modelo.dataInicioVigencia = self.novoSeguro.dataVigencia;
            modelo.expectativa = self.novoSeguro.expectativa;
            modelo.tipoSeguro = self.novoSeguro.tipoSeguro;

            if (self.boolContatoAverbacao) { //O mesmo
                modelo.contatos = [{
                    nome: contatoUsuario.nome,
                    email: contatoUsuario.email,
                    ddd: contatoUsuario.ddd,
                    telefone: contatoUsuario.telefone
                }]
            } else {
                modelo.contatos = [self.novoSeguro.contato];
            }

            return modelo;
        },
        zeraTaxaDescontoNovoSeguroTextField: function () {
          const self = this;
          if (self.taxaDescontoNovoSeguroRadioStr == 'taxa') {
            if (!!document.getElementById('txtNovoSeguroDescontoDesejado')) {
              self.$refs.txtNovoSeguroDescontoDesejadoLabelRef.$el.getElementsByTagName('input')[0].value = 0.00;
              self.$refs.txtNovoSeguroDescontoDesejadoLabelRef.reset();
            }
          } else if (self.taxaDescontoNovoSeguroRadioStr == 'desconto') {
            if (!!document.getElementById('txtNovoSeguroTaxaDesejada')) {
              self.$refs.txtNovoSeguroTaxaDesejadaLabelRef.$el.getElementsByTagName('input')[0].value = 0.000;
              self.$refs.txtNovoSeguroTaxaDesejadaLabelRef.reset();
            }
          }
        }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/questionario/NovoSeguroQ.vue